import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { HubspotPreDefinedType, PreDefinedResponse } from "../../types/shared";

export type HubspotPredefinedApiServiceType = {
    getHsPreDefinedColumns(type: HubspotPreDefinedType, cacheToken: string): Promise<PreDefinedResponse>;
};

export const hubspotPredefinedApiService = (fetchService: IFetchService): HubspotPredefinedApiServiceType => {
    return {
        getHsPreDefinedColumns: createCancelable(
            (signal: AbortSignal, type: HubspotPreDefinedType, cacheToken: string): Promise<PreDefinedResponse> => {
                return fetchService.get(
                    `sales-api/hubspot/predefined-${type}-columns?cacheToken=${cacheToken}`,
                    undefined,
                    {
                        cancellation: signal,
                    },
                );
            },
        ),
    };
};
